import React from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";

const { TabPane } = Tabs;

const CampaignsTabs = ({ tabs, activeTab, onChange }) => {
  const { t } = useTranslation();
  return (
    <Tabs activeKey={String(activeTab)} onChange={onChange}>
      {tabs.map((tab) => (
        <TabPane key={String(tab.tab)} tab={t(tab.labelKey)} />
      ))}
    </Tabs>
  );
};

export default CampaignsTabs;
